import { GlModal, GlSprintf, GlIcon } from '@gitlab/ui';
import { createAlert } from '~/alert';
import { __, n__, s__, sprintf, formatNumber } from '~/locale';
import workItemsCsvExportMutation from '../graphql/work_items_csv_export.mutation.graphql';
export default {
    name: 'WorkItemsCsvExportModal',
    actionCancel: {
        text: __('Cancel')
    },
    i18n: {
        workItemExportTitle: s__('WorkItem|Export work items'),
        workItemErrorMessage: s__('WorkItem|An error occurred while exporting work items.'),
        exportText: s__('WorkItem|The CSV export will be created in the background. Once finished, it will be sent to %{email} in an attachment.')
    },
    components: {
        GlModal,
        GlSprintf,
        GlIcon
    },
    inject: {
        userExportEmail: {
            default: ''
        }
    },
    props: {
        workItemCount: {
            type: Number,
            required: true
        },
        modalId: {
            type: String,
            required: true
        },
        queryVariables: {
            type: Object,
            required: false,
            default: ()=>({})
        }
    },
    data () {
        return {
            isExporting: false
        };
    },
    computed: {
        actionPrimary () {
            return {
                text: this.$options.i18n.workItemExportTitle,
                attributes: {
                    variant: 'confirm',
                    loading: this.isExporting,
                    'data-testid': 'export-work-items-button',
                    'data-track-action': 'click_button',
                    'data-track-label': 'export_work_items_csv'
                }
            };
        },
        workItemCountText () {
            return sprintf(n__('%{count} work item selected', '%{count} work items selected', this.workItemCount), {
                count: formatNumber(this.workItemCount)
            });
        }
    },
    methods: {
        async exportWorkItems () {
            this.isExporting = true;
            try {
                const { data } = await this.$apollo.mutate({
                    mutation: workItemsCsvExportMutation,
                    variables: {
                        input: {
                            ...this.queryVariables
                        }
                    }
                });
                const { message } = data.workItemsCsvExport || {};
                if (message) {
                    createAlert({
                        message,
                        variant: 'success'
                    });
                    this.$refs.modal?.hide();
                }
            } catch (error) {
                createAlert({
                    message: this.$options.i18n.workItemErrorMessage
                });
            } finally{
                this.isExporting = false;
            }
        }
    }
};
